(function () {
  function saveTrafficSource() {
    try {
      const hasUTM = window.location.search.includes("utm_");

      if (!hasUTM) return;

      const pathAndQuery = window.location.pathname + window.location.search;

      updateCartAttributes(pathAndQuery);
    } catch (error) {
      console.error("Error saving traffic source:", error);
    }
  }

  function updateCartAttributes(pathAndQuery) {
    try {
      const cartUpdateData = {
        attributes: {
          utm_tracking: pathAndQuery,
        },
      };

      fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(cartUpdateData),
      })
        .then((response) => {
          if (!response.ok) throw new Error("Failed to update cart attributes");
          return response.json();
        })
        .then((data) => {
          console.log("Cart attributes updated successfully:", data.attributes);
        })
        .catch((error) =>
          console.error("Error updating cart attributes:", error)
        );
    } catch (error) {
      console.error("Unexpected error updating cart:", error);
    }
  }

  document.addEventListener("DOMContentLoaded", saveTrafficSource);
})();
